var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-time-with-note',{attrs:{"details":_vm.details,"comment":_vm.comment,"type":"punch-out"}})
}
var staticRenderFns = []

export { render, staticRenderFns }